export class Percentage {
  value?: number;
  decimals: number = 2;

  constructor(value?: number, decimals?: number) {
    this.value = value;
    this.decimals = decimals ?? this.decimals;
  }
}
